module.exports = __webpack_public_path__ + "img/customer-a-073.86c89f35.png";